import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import {
  linkColor,
  themeColorBlue,
  accessibilityColors,
} from '@edulastic/colors'

const BreadCrumb = (props) => {
  const { data, style, ellipsis, hasStickyHeader } = props

  return (
    <Container
      ellipsis={ellipsis}
      style={style}
      hasStickyHeader={hasStickyHeader}
    >
      <BreadcrumbList aria-label={`breadcrumb with ${data.length} items`}>
        <Separator aria-hidden="true" marginLR="5px">
          {'<'}
        </Separator>
        {Array.isArray(data) &&
          data.map((breadCrumb = {}, index) => (
            <BreadcrumbItem key={`bread${index}`}>
              {breadCrumb.to ? (
                <>
                  <Link
                    to={
                      breadCrumb.state
                        ? {
                            pathname: breadCrumb.to,
                            state: breadCrumb.state,
                            ...(breadCrumb.search
                              ? { search: breadCrumb.search }
                              : {}),
                          }
                        : breadCrumb.to
                    }
                    onClick={breadCrumb.onClick}
                    aria-current={breadCrumb.title}
                    tabIndex={0}
                  >
                    {/* pass search here after processing the string or process string here by calling a helper function in utils, currently no such requirement */}
                    <span
                      data-cy={`${breadCrumb.title?.toLowerCase()}BreadCrumb`}
                    >
                      {breadCrumb.title?.toLowerCase()}
                    </span>
                  </Link>
                </>
              ) : (
                <span
                  data-cy={`${breadCrumb.title?.toLowerCase()}BreadCrumb`}
                  role="link"
                  aria-label={breadCrumb.title}
                  tabIndex={0}
                  aria-current="page"
                >
                  {breadCrumb.title?.toLowerCase()}
                </span>
              )}
              {index !== data.length - 1 && (
                <Separator aria-hidden="true">/</Separator>
              )}
            </BreadcrumbItem>
          ))}
      </BreadcrumbList>
    </Container>
  )
}

BreadCrumb.propTypes = {
  data: PropTypes.array.isRequired,
  style: PropTypes.object,
}

BreadCrumb.defaultProps = {
  style: {},
}

export default BreadCrumb

const EllipsisStyle = css`
  max-width: ${(props) => props.ellipsis || ''};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
`

const Container = styled.div`
  position: fixed;
  top: 80px;
  display: ${(props) => (props.hasStickyHeader ? 'none' : 'intial')};

  .ant-breadcrumb-link {
    cursor: pointer;
    &:hover {
      color: ${themeColorBlue};
    }
  }
`

const Separator = styled.span`
  margin: 0 ${({ marginLR }) => marginLR || `10px`};
  font-size: 11px;
  color: ${linkColor};
  text-transform: uppercase;
`

const BreadcrumbList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
`

const BreadcrumbItem = styled.li`
  font-size: 11px;
  color: ${linkColor};
  text-transform: uppercase;
  display: flex;
  font-weight: 600;
  white-space: nowrap;

  a {
    text-transform: uppercase;
    color: ${linkColor};
    ${(props) => props.ellipsis && EllipsisStyle}
    color: ${themeColorBlue};
    &:focus {
      outline: ${accessibilityColors.theme.blueHover} solid 2px;
      border-radius: 2px;
    }
  }

  span {
    text-transform: uppercase;
    ${(props) => props.ellipsis && EllipsisStyle}
  }
`
